var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{on:{"click":_vm.toggleDropdown}},[_vm._t("link")],2),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"dropdown-content"},[_vm._t("dropdown")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }